import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/perfunnel-ui-v1_release_26.11.04@2/app/error.tsx");
